import type { Filter } from './analytics'
import type { Dimension, Measure, Order } from './cube'
import type { CustomTimeGrain, DateRange, TimeGrain } from './timeDimension'

export interface TimeDimension {
  dimension: string
  dateRange: DateRange
  granularity?: TimeGrain | CustomTimeGrain
}

export interface TimeDimensionWithComparison {
  dimension: string
  compareDateRange: DateRange[]
  granularity?: TimeGrain | CustomTimeGrain
}

export interface MinimalQuery {
  measures: string[]
}

export type Executable<Type extends MinimalQuery> = Omit<Type, 'measures'> & {
  measures: [string, ...string[]]
}

export type ListExplorerQuery = MinimalQuery & {
  dimensions: string[]
  filters: Filter[]
  order?: Order[] | undefined
}

export type GenericExplorerQuery = MinimalQuery & {
  dimensions: string[]
}

export type PartialQuery = Executable<MinimalQuery> & {
  dimensions?: string[]
  filters?: Filter[]
  order?: Order[]
  total?: boolean
  limit?: number
}

export enum QueryStatus {
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE'
}

export type Query = PartialQuery &
  Required<Pick<PartialQuery, 'dimensions' | 'filters'>> & {
    timeDimensions: TimeDimension[] | TimeDimensionWithComparison[]
  }

export type QueryWithStatus = Query & {
  status: QueryStatus
}

export type ExplicitQuery = {
  measures: [Measure, ...Measure[]]
  dimensions: Dimension[]
}

export type ResultSetItemValue = number | string | boolean | null

export interface ResultSetItem {
  [key: string]: ResultSetItemValue
}

export interface ResultSetData {
  data: ResultSetItem[]
  total: number | null
}

export type QueryResults = ResultSetData & {
  query: ExplicitQuery
}
